// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalStyles } from "@conklin/Overrides/Widgets/Cart/CartTotal";
import { color, mergeWithCss } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cartTotalStyles.fulfillmentMethods = {
    css: css`
        padding: 12px 0px;
        border-bottom: 1px solid ${color("common.border")};
        border-top: 1px solid ${color("common.border")};
        margin-top: 12px;
    `,
};

cartTotalStyles.domesticWrapper = {
    css: css`
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
        margin-top: 12px;
    `,
};

cartTotalStyles.messageText = {
    ...orderTotalDisplaySharedStyles.microCopyText,
};

cartTotalStyles.checkoutButton = {
    css: css`
        width: 100%;
        margin-top: 12px;
    `,
};

cartTotalStyles.cancelPunchOutButton = cartTotalStyles.submitRequisitionButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 12px;
    `,
};

cartTotalStyles.submitQuoteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

cartTotalStyles.quoteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 16px;
    `,
};

cartTotalStyles.internationalMessageText = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.microCopyText, {
        color: "danger.main",
    }),
};
